export const PASPORT_TOKEN = '#'
export const PASPORT_PATTERN = /[a-zA-Z0-9]/
export const PASPORT_MASK = PASPORT_TOKEN.repeat(20)
export const PASPORT_MAX_LENGTH = PASPORT_MASK.length
